/**
 * The id of one tab's visit: twelve hex characters, random, nothing of hers in it, kept in the tab's
 * own storage so a reload is the same visit and a new tab is a new one. Every teacher event carries
 * it (lib/events.ts) and so does every api request (api/client.ts), so one visit's events, and what
 * the server did in them, can be read together. The api drops a malformed one. One owner: this module.
 * Where storage is off the id lives for the page load, and a reload is a new visit.
 */
const KEY = 'tt-visit-id'
const SHAPE = /^[a-f0-9]{12}$/

let current: string | null = null

function stored(): string | null {
	try {
		const id = sessionStorage.getItem(KEY)
		return id && SHAPE.test(id) ? id : null
	} catch {
		return null
	}
}

function make(): string {
	const bytes = new Uint8Array(6)
	crypto.getRandomValues(bytes)
	return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

/** This visit's id, made on first use. Only teacher code calls this: a student's page has no visit. */
export function visitId(): string {
	current ??= stored()
	if (!current) {
		current = make()
		try {
			sessionStorage.setItem(KEY, current)
		} catch {
			// Kept in memory for this page load.
		}
	}
	return current
}

/** The id if the visit has one, without making it: for requests that may come from a student's page. */
export const peekVisit = (): string | null => current ?? stored()
